import React, { useState } from "react";
import { HeaderRoutes } from "./HeaderItem";
import amancv from "../assets/cv/amanSingh - Frontend Developer.pdf";
import { FaBars, FaTimes } from "react-icons/fa";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const handleScroll = (e, href) => {
    e.preventDefault(); // Prevent default link behavior

    if (href.startsWith("#")) {
      const sectionId = href.substring(1); // Remove '#' from href
      const section = document.getElementById(sectionId);
      if (section) {
        window.scrollTo({
          top: section.offsetTop - 50, // Adjust if there's a fixed navbar
          behavior: "smooth",
        });
      }
    } else {
      window.location.href = href; // If it's an external route, navigate normally
    }
  };
  return (
    <div className="header">
      <>
        <div className="flex justify-center items-center ">
          <img
            className="w-[50px] h-[50px] rounded-full"
            src={require("../assets/logo.png")}
          />
        </div>
        <div className="flex justify-center items-center gap-10">
          <div className="hidden md:block">
            <ul className="flex justify-center gap-6 font-semibold snip1175">
              {HeaderRoutes.map((route, idx) => (
                <li className="" key={route.title}>
                  {" "}
                  <a
                    data-hover={route.title}
                    href={route.href}
                    onClick={(e) => handleScroll(e, route.href)}
                  >
                    {route.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="hidden md:block">
            <a className="" href={amancv} download="AmanSingh">
              <button className="header-btn ">
                Download CV <i class="fa-solid fa-download"></i>
              </button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMenu}
              className="text-[#ffffff] rounded-full border p-4 focus:outline-none"
            >
              {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>
      </>
      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden absolute top-16 left-0 w-[100%] bg-white shadow-md py-6 mt-2 border-[4px] border-[#02343f] flex flex-col items-center bg-[#fff]">
          {HeaderRoutes.map((route) => (
            <a
              key={route.title}
              href={route.href}
              onClick={(e) => handleScroll(e, route.href)}
              className="text-[#02343F] hover:text-blue-600 transition py-2"
            >
              {route.title}
            </a>
          ))}
          <a href={amancv} download="AmanSingh" className="mt-2">
            <button className="bg-blue-600 text-[#fff] px-4 py-2 rounded-md bg-[#02343f]">
              Download CV
            </button>
          </a>
        </div>
      )}
    </div>
  );
};

export default Header;
